<div class="popover-password">
  <p class="typo-20-semibold-green">Les modifications de votre mot de passe ont bien été prises en compte.</p>

  <div class="buttons">
    <ion-button class="typo-16-bold-white ion-text-uppercase" (click)="dismiss()">Fermer</ion-button>
  </div>
</div>

